import axios from '@axios'

export default {
  namespaced: true,
  state: {
    applicationsList: [],
    childApplicationsList: [],
  },
  getters: {
    getApplicationsList: state => state.applicationsList,
    getChildApplicationsList: state => state.childApplicationsList,
  },
  mutations: {
    SET_ALL_APPLICATIONS: (state, data) => {
      state.applicationsList = data
    },
    SET_CHILD_APPLICATIONS_LIST: (state, data) => {
      state.childApplicationsList = data
    },
  },
  actions: {
    fetchChildApplicationsList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/children-with-applications', {
            params: queryParams,
          })
          .then(response => {
            ctx.commit('SET_CHILD_APPLICATIONS_LIST', response.data.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchApplicationsList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/applications', {
            params: queryParams,
          })
          .then(response => {
            ctx.commit('SET_ALL_APPLICATIONS', response.data.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchApplicationById(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/applications/${id}`)
          .then(response => resolve(response.data.data))
          .catch(error => reject(error))
      })
    },
  },
}